import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import css from "./UlForMenu.module.css";
import { getMenuItems } from "../../constants";
import { useRoleAccess } from "../../hooks/useRoleAccess";

const UlForMenu = ({ onMenuClose, isMobile }) => {
  const { t } = useTranslation();
  const { userRole } = useRoleAccess();

  const menuItems = getMenuItems(t, userRole);

  const handleMenuItemClick = () => {
    if (isMobile && onMenuClose) {
      onMenuClose();
    }
  };

  return (
    <ul className={css.wrap}>
      {menuItems.map(({ name, icon, linkForRoute, allowedRoles }) =>
        allowedRoles ? (
          <li key={name}>
            <NavLink
              to={`/${linkForRoute.toLowerCase()}`}
              className={({ isActive }) =>
                `${css.menuItem} ${isActive ? css.active : ""}`
              }
              onClick={handleMenuItemClick}
            >
              <span className={css.icon}>{icon}</span>
              <span className={css.menuText}>{name}</span>
            </NavLink>
          </li>
        ) : null
      )}
    </ul>
  );
};

export { UlForMenu };
